export default __webpack_public_path__ + "img/c8e2b0d14d7898891bd535a292db38be.png";